<template>
  <div cy-id="login">
    <!-- Header -->
    <div class="header bg-albert-primary py-7 py-lg-8 pt-lg-9">
      <!--      <div class="container">-->
      <!--        <div class="header-body text-center mb-7">-->
      <!--          <div class="row justify-content-center">-->
      <!--            <div class="col-xl-5 col-lg-6 col-md-8 px-5">-->
      <!--              <h1 class="text-white">Welcome!</h1>-->
      <!--              <p class="text-lead text-white">Use these awesome forms to login or create new account in your project for free.</p>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          xmlns="http://www.w3.org/2000/svg"
          y="0"
        >
          <polygon class="fill-albert-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <!--            <div class="card-header bg-transparent pb-5">-->
            <!--              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>-->
            <!--              <div class="btn-wrapper text-center">-->
            <!--                <a href="#" class="btn btn-neutral btn-icon">-->
            <!--                  <span class="btn-inner&#45;&#45;icon"><img src="img/icons/common/github.svg"></span>-->
            <!--                  <span class="btn-inner&#45;&#45;text">Github</span>-->
            <!--                </a>-->
            <!--                <a href="#" class="btn btn-neutral btn-icon">-->
            <!--                  <span class="btn-inner&#45;&#45;icon"><img src="img/icons/common/google.svg"></span>-->
            <!--                  <span class="btn-inner&#45;&#45;text">Google</span>-->
            <!--                </a>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Ingresa tus credenciales</small>
              </div>
              <form role="form">
                <base-input
                  v-model="model.email"
                  cy-id="email"
                  alternative
                  class="mb-3"
                  name="email"
                  placeholder="Email"
                  prepend-icon="fas fa-envelope"
                >
                </base-input>

                <base-input
                  v-model="model.password"
                  cy-id="password"
                  alternative
                  class="mb-3"
                  name="password"
                  placeholder="Contraseña"
                  prepend-icon="fas fa-unlock-alt"
                  type="password"
                  @keyup.enter="signIn"
                >
                </base-input>

                <div class="text-muted font-italic">
                  <small
                    ><span class="text-danger font-weight-700">{{ error }}</span></small
                  >
                </div>

                <base-checkbox v-model="model.rememberMe">Recuérdame</base-checkbox>

                <div class="text-center">
                  <base-button :loading="isLoading" cy-id="submit" class="my-4" type="primary" @click="signIn">
                    <i class="fas fa-sign-in-alt"></i><span>&nbsp;Ingresar</span>
                  </base-button>
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <!--              <router-link to="/dashboard" class="text-light"><small>Forgot password?</small></router-link>-->
            </div>
            <div class="col-6 text-right">
              <router-link class="text-light" to="/register"><small>Crear nueva cuenta</small></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        email: '',
        password: '',
        rememberMe: true,
      },

      context: 'login',
      isLoading: false,
      error: '',
    };
  },

  methods: {
    signIn() {
      this.isLoading = true;
      this.error = '';

      if (this.model.email === '') {
        this.error = 'Ingrese un email';
        this.isLoading = false;
        return;
      }

      if (this.model.password === '') {
        this.error = 'Ingrese una contraseña';
        this.isLoading = false;
        return;
      }

      // Login In
      this.$auth.login({
        data: this.model,
        success: (res) => {},
        error: (err) => {
          this.$error('Credenciales incorrectas.');
          this.error = 'Credenciales incorrectas.';
          this.isLoading = false;
        },
        rememberMe: this.model.rememberMe,
        redirect: '/dashboard',
      });
    },
  },
};
</script>
